// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const binacle: PokeData = {
  "id": 688,
  "name": "binacle",
  "height": 5,
  "weight": 310,
  "base_experience": 61,
  "types": [
    PokeType.ROCK,
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "water-gun",
    "withdraw",
    "clamp",
    "fury-swipes",
    "slash",
    "mud-slap",
    "fury-cutter",
    "cross-chop",
    "ancient-power",
    "rock-polish",
    "night-slash",
    "hone-claws",
    "shell-smash",
    "razor-shell"
  ],
  "moves": [
    "scratch",
    "mud-slap",
    "ancient-power",
    "night-slash",
    "brine",
    "stone-crush",
    "rock-throw",
    "rain-dance",
    "boulder_bash",
    "aqua-tail",
    "rock-smash",
    "bubble-beam",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 353,
    "item": null,
    "species": [
      {
        "name": "binacle",
        "order": 689,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "barbaracle",
        "order": 690,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": 688,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.75,
    "speed": 50,
    "ability_power": 52
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
